<div class="flex h-[78vh] flex-col">
  @if (!!clientProfile()) {
    <div
      class="mx-3 mb-2 flex cursor-pointer items-center justify-center rounded-lg bg-gray-3 p-3 shadow-xl"
      (click)="navigateToClientProfile(clientProfile().id)"
    >
      <h4 class="flex items-center gap-2">
        <mat-icon class="min-w-[24px]">account_circle</mat-icon>
        <span>{{ clientProfile().fullName }}</span>
      </h4>
    </div>
  }
  @if (loading()) {
    <div class="flex w-full items-center justify-end">
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    </div>
  }

  <div
    #messageContainer
    class="flex min-w-0 flex-1 flex-col gap-2 overflow-y-auto overflow-x-hidden px-3"
  >
    <div
      #scrollTick
      class="h-[1px] flex-none"
    ></div>

    @for (message of innerMessages(); track $index) {
      @if (hasUnreadMessages() && $index === getUnreadMarkerPosition()) {
        <div class="m-4 flex w-full items-center justify-center gap-3 bg-white text-sm">
          <span>непрочитані повідомлення</span>
          <a
            class="cursor-pointer text-blue-primary underline"
            (click)="onMarkAsRead()"
          >
            прочитати
          </a>
        </div>
      }
      <chat-message
        [index]="$index"
        [ownUserId]="ownUserId()"
        [threadUserId]="threadUserId()"
        [message]="message"
        [attr.data-id]="message.id"
        [attr.data-index]="$index"
      ></chat-message>
    }
    <div
      #scrollEndTick
      class="h-[1px] flex-none"
    ></div>
  </div>
  <div class="mx-3 mt-1">
    <form>
      @if (showEmojis()) {
        <div class="flex items-end justify-end">
          <emoji-mart
            [showPreview]="false"
            [enableSearch]="false"
            [emojiTooltip]="true"
            [color]="'text-gray-3'"
            (emojiSelect)="selectEmoji($event, messageInput)"
          ></emoji-mart>
        </div>
      }
      <mat-form-field class="-mb-6 w-full">
        <mat-icon
          matIconPrefix
          (click)="openFileBuffer()"
        >
          <input
            #fileInput
            class="hidden"
            type="file"
            multiple
            (change)="onFileSelected($event)"
          />
          attach_file
        </mat-icon>
        <mat-label>{{ "Надіслати повідомлення" }}</mat-label>
        <textarea
          cdkTextareaAutosize
          cdkAutosizeMaxRows="16"
          #messageInput
          matInput
          [formControl]="messageTextFc"
        ></textarea>
        <button
          matSuffix
          mat-icon-button
          aria-label="Emojis"
          [type]="'button'"
          (click)="toggleEmojis()"
        >
          <mat-icon>mood</mat-icon>
        </button>
        <button
          matSuffix
          mat-icon-button
          aria-label="Send"
          [type]="'button'"
          [disabled]="!messageTextFc.valid || loading()"
          (click)="onSendMessage()"
        >
          <mat-icon>send</mat-icon>
        </button>
      </mat-form-field>
    </form>
  </div>
</div>
